import React from 'react';

import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './SparkThreeUp.module.css';

const SparkThreeUp = ({ section }) => {
  return (
    <PageSection slim className={styles.grey}>
      <h2>{section.heading}</h2>
      <RichTextConverter copy={section.copy} />
      <div className={styles.sparkGrid}>
        {section.content.map((card, i) => {
          return (
            <div key={i}>
              <span className={styles.subtitle}>{card.subtitle}</span>
              <h2>{card.title}</h2>
              <RichTextConverter copy={card.body} />
            </div>
          );
        })}
      </div>
    </PageSection>
  );
};

SparkThreeUp.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default SparkThreeUp;
